// GPT API 配置檔案 - 前端版本
// 統一管理所有 GPT API 的配置和密鑰

// 各模組的 API 選項配置
// 0: OpenAI GPT-4o-mini, 1: OpenAI GPT-4o, 2: DeepSeek, 3: Perplexity
const MODULE_API_OPTIONS = {
  news: 3,            // list_News.js 使用 Perplexity (新聞分析)
  screener: 3,        // StockScreener.js 使用 DeepSeek (智能選股)
  business: 3,        // business-product.js 使用 Perplexity (避免 DeepSeek 瀏覽器 CORS)
};

// 預設 API 選項（當模組未指定時使用）
const DEFAULT_API_OPTION = 2;

// API 密鑰配置
const API_KEYS = {
  DEEPSEEK: 'sk-b4714b9ffd854e97a790a3c8d61c4282',
  OPENAI: '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',
  PERPLEXITY: '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'
};

// API 配置映射
const API_CONFIGS = {
  0: { // OpenAI GPT-4o-mini
    key: API_KEYS.OPENAI,
    host: 'api.openai.com',
    model: 'gpt-4o-mini',
    name: 'OpenAI (GPT-4o-mini)',
    maxTokens: 5000,
    models: [
      'gpt-4o-mini',
      'gpt-4o',
      'gpt-4.1-mini'
    ]
  },
  1: { // OpenAI GPT-4o
    key: API_KEYS.OPENAI,
    host: 'api.openai.com',
    model: 'gpt-4o',
    name: 'OpenAI (GPT-4o)',
    maxTokens: 8000,
    models: [
      'gpt-4o',
      'gpt-4o-mini',
      'gpt-4.1'
    ]
  },
  2: { // DeepSeek
    key: API_KEYS.DEEPSEEK,
    host: 'api.deepseek.com',
    model: 'deepseek-chat',
    name: 'DeepSeek',
    maxTokens: 8000,
    models: [
      'deepseek-chat',
      'deepseek-reasoner'
    ]
  },
  3: { // Perplexity
    key: API_KEYS.PERPLEXITY,
    host: 'api.perplexity.ai',
    model: 'sonar-reasoning-pro',
    name: 'Perplexity',
    maxTokens: 8000,
    models: [
      'sonar-reasoning-pro',
      'llama-3.1-sonar-huge-128k-online',
      'llama-3.1-sonar-small-128k-online'
    ]
  }
};

// 獲取指定模組的 API 配置
function getModuleAPIConfig(moduleName) {
  const apiOption = MODULE_API_OPTIONS[moduleName] || DEFAULT_API_OPTION;
  const config = API_CONFIGS[apiOption] || API_CONFIGS[0]; // 默認使用 GPT-4o-mini
  return {
    API_KEY: config.key,
    API_HOST: config.host,
    API_MODEL: config.model,
    API_NAME: config.name,
    API_MAX_TOKENS: config.maxTokens,
    API_OPTION: apiOption,
    API_MODELS: config.models
  };
}

// 獲取當前 API 配置（向後兼容）
function getCurrentAPIConfig() {
  return getModuleAPIConfig('default');
}

// 導出配置
export {
  MODULE_API_OPTIONS,
  DEFAULT_API_OPTION,
  API_KEYS,
  API_CONFIGS,
  getModuleAPIConfig,
  getCurrentAPIConfig
};
